export function AdminWorkspaceNav({ groups, activeId, onSelect }) {
  return <nav aria-label="Yönetim bölümleri" className="flex gap-2 overflow-x-auto pb-1 lg:flex-col lg:overflow-visible">
    {groups.map((group) => <div key={group.label} className="shrink-0 lg:mb-4">
      <p className="mb-2 hidden px-3 text-[10px] font-bold uppercase tracking-[.16em] text-ink/40 lg:block">{group.label}</p>
      <div className="flex gap-2 lg:flex-col">
        {group.items.map(({ id, label, icon: Icon }) => <button key={id} type="button" onClick={() => onSelect(id)} aria-current={activeId === id ? "page" : undefined} className={activeId === id ? "admin-nav-item admin-nav-item-active" : "admin-nav-item"}><Icon className="h-4 w-4 shrink-0" />{label}</button>)}
      </div>
    </div>)}
  </nav>;
}
